import { render, staticRenderFns } from "./SubCategories.vue?vue&type=template&id=10f29a61&scoped=true"
import script from "./SubCategories.vue?vue&type=script&lang=js"
export * from "./SubCategories.vue?vue&type=script&lang=js"
import style0 from "./SubCategories.vue?vue&type=style&index=0&id=10f29a61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f29a61",
  null
  
)

export default component.exports